import { Address as AddressObject, ContentStateInterface } from '../../../@types/types'

export const addressToGeoApi = (insertionData: ContentStateInterface): AddressObject => ({
  street: insertionData.street,
  houseNumber: insertionData.houseNumber,
  postcode: insertionData.postcode,
  city: insertionData.city,
})
